import { render } from "./NodeDescription.vue?vue&type=template&id=031e9abd"
import script from "./NodeDescription.vue?vue&type=script&lang=ts"
export * from "./NodeDescription.vue?vue&type=script&lang=ts"
script.render = render

export default script